import { GetPublishDataType, IBaseRequestResponseDataType } from '../../../../../common/scripts/Connection/Connection';
import DataType from './DataStructure';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const PathName = {
    Ack: 'game.ack',
    Login: 'auth.login',
    Balance: 'auth.balance',
    Error: 'error',
    // Hall
    HallOverview: 'game.halls.overview',
    HallStats: 'game.halls.stats',
    HallTableList: 'game.halls.tables',
    JackpotStatus: 'game.jackpot.status',
    JackpotRecord: 'game.jackpot.record',
    // not implemented yet
    DeviceInfo: 'device.info',
    DeviceList: 'device.list',

    // Table
    EnterTable: 'game.table.entry',
    ExitTable: 'game.table.current.exit',
    TableStream: 'game.table.current.stream',
    PlayerSettle: 'game.table.current.player.settle',
    PlayerStatus: 'game.table.current.player.status',
    Touch: 'game.table.current.touch',
    Bet: 'game.table.current.bet',
    TableSummary: 'game.table.current.summary',
    // DeviceTouch: 'game.table.device.touch',

    AvatarList: 'avatar.list',
    InfoUpdate: 'info.update',
} as const;

export interface IRequestResponseDataType extends IBaseRequestResponseDataType {
    [PathName.Ack]: [undefined, never];
    [PathName.Login]: [DataType.User.RequestData, DataType.User.ResponseData];
    [PathName.HallOverview]: [DataType.Hall.OverviewRequestData, DataType.Hall.OverviewResponseData];
    [PathName.HallStats]: [DataType.Hall.StatsRequestData, DataType.Hall.StatsResponseData];
    [PathName.HallOverview]: [DataType.Hall.OverviewRequestData, DataType.Hall.OverviewResponseData];
    [PathName.HallTableList]: [DataType.Hall.TableListRequestData, DataType.Hall.TableListResponseData];
    [PathName.EnterTable]: [DataType.Table.EnterRequestData, DataType.Table.EnterResponseData];
    [PathName.ExitTable]: [undefined, DataType.Table.ExitResponseData];
    [PathName.JackpotRecord]: [undefined, DataType.Jackpot.RecordResponseData];
    [PathName.TableStream]: [undefined, DataType.Table.StreamData];
    [PathName.Bet]: [DataType.Bet.RequestData, DataType.Bet.ResponseData];

    // not implemented yet
    [PathName.DeviceInfo]: [DataType.Device.InfoRequestData, DataType.Device.InfoResponseData];
    [PathName.DeviceList]: [undefined, DataType.Device.ListResponseData];
    [PathName.Touch]: [DataType.Device.TouchData, DataType.Device.TouchData];

    [PathName.PlayerStatus]: [undefined, DataType.Table.PlayerStatusData];
    [PathName.TableSummary]: [undefined, DataType.Table.SummaryData];
}

export type PublishDataType = GetPublishDataType<IRequestResponseDataType> & {
    [PathName.PlayerSettle]: DataType.Table.PlayerSettleData;
    [PathName.JackpotStatus]: DataType.Jackpot.StatusResponseData;
};
